import { shopifyService } from '@/services/shopifyService';

interface ShopifyConfig {
  shopDomain: string;
  accessToken: string;
}

// Öffentliche Shopify Storefront Credentials - sicher im Code zu speichern
const DEFAULT_CONFIG: ShopifyConfig = {
  shopDomain: 'mandatory-outfitter.myshopify.com',
  accessToken: 'c0f802098282166caa117dfc633d8199'
};

class ShopifyConfiguration {
  private static instance: ShopifyConfiguration;
  private config: ShopifyConfig;

  private constructor() {
    // Verwende immer die Standard-Konfiguration
    this.config = DEFAULT_CONFIG;
    // Konfiguriere den Service direkt beim Start
    shopifyService.configure(this.config.shopDomain, this.config.accessToken);
  }

  static getInstance(): ShopifyConfiguration {
    if (!ShopifyConfiguration.instance) {
      ShopifyConfiguration.instance = new ShopifyConfiguration();
    }
    return ShopifyConfiguration.instance;
  }

  isConfigured(): boolean {
    return !!this.config.shopDomain && !!this.config.accessToken;
  }

  getConfig(): ShopifyConfig {
    return this.config;
  }
}

export const shopifyConfig = ShopifyConfiguration.getInstance();